const SixBExpenditureContent = `

Expenditure on advertisement.

6B. [Omitted by the IT (Thirty-second Amdt.) Rules, 1999, w.e.f. 19-11-1999.] 


`;

export default SixBExpenditureContent;